
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voicemail",
      function () {
        return require("private-next-pages/voicemail/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voicemail"])
      });
    }
  